import {Row} from 'antd';
import classes from '../Pages.module.css';
import DataField from './DataField';
import TrainingEdit from './TrainingEdit';

const Training = (props) => {
    return(
        !props.editMode
        ?
        props.data.map((data, index) => {
            return(
                <div key = {index}>
                    <p></p>
                    <Row className = {props.editMode ? classes['RowDEX'] : classes['RowD']}>
                        <DataField editMode = {false} lg = {8} md = {24} name = "INSTITUTE" value = {data.institute}/> 
                        <DataField editMode = {false} lg = {8} md = {24} name = "START DATE" value = {!data.start_date ? null : data.start_date.format('DD-MM-YYYY')}/> 
                        <DataField editMode = {false} lg = {8} md = {24} name = "DURATION" value = {data.duration}/> 
                        <DataField editMode = {false} lg = {24} md = {24} name = "SKILLS ACQUIRED" value = {data.skill_acquired}/>          
                    </Row>  
                    <p></p>
                </div>
            );
        })
           
        :
        <>
            <p></p>
            <TrainingEdit data = {props.data} setData = {props.setData} />
        </>
    );
}

export default Training